import React from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { SuiteMaximo } from "../components/site/SuiteMaximo";
import { About } from "../components/site/About";
import { Rooms } from "../components/site/Rooms";
import { Gallery } from "../components/site/Gallery";
import { Amenities } from "../components/site/Amenities";
import { Location } from "../components/site/Location";
import { Reviews } from "../components/site/Reviews";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { WhatsAppFloat } from "../components/site/WhatsAppFloat";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="w-full min-h-screen overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <SuiteMaximo />
        <About />
        <Rooms />
        <Gallery />
        <Amenities />
        <Location />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
